import globalWindow from '@shared/core/globals';

export const newrelic = globalWindow.newrelic;

const isError = (err: unknown): err is Error => err instanceof Error;

export function addAction(actionName: string, value?: object): void {
  const valueWithPrefixes: object = {};

  for (const key in value) {
    valueWithPrefixes[`${actionName}_${key}`] = value[key];
  }

  newrelic?.addPageAction(actionName, valueWithPrefixes);
}

export function addError(error: unknown, context?: object) {
  let errorValue;

  if (isError(error)) {
    errorValue = error;
  } else if (typeof error === 'string') {
    errorValue = new Error(error);
  } else {
    errorValue = new Error('unknown');
  }

  newrelic?.noticeError(errorValue, context);
}
